import { render } from "./WelcomeView.vue?vue&type=template&id=5d2ca530"
const script = {}

import "./WelcomeView.vue?vue&type=style&index=0&id=5d2ca530&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__